module.exports = __webpack_public_path__ + "img/k-skyblue-woman-back.ee31273e.jpg";